var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import updateDeviceName from '../../requests/devices/updateDeviceName';
/**
 *
 */
var UpdateDeviceNameCommand = /** @class */ (function (_super) {
    __extends(UpdateDeviceNameCommand, _super);
    function UpdateDeviceNameCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param desiredName string
     * @param device DeviceModel
     * @param organisationId string
     * @return {*}
     */
    UpdateDeviceNameCommand.prototype.execute = function (desiredDeviceName, deviceModel, organisationId) {
        this.deviceModel = deviceModel;
        var promise = updateDeviceName({ desiredDeviceName: desiredDeviceName }, organisationId, deviceModel.link_device_id);
        return promise;
    };
    return UpdateDeviceNameCommand;
}(Command));
export default UpdateDeviceNameCommand;
